import { gql } from "@apollo/client";

export const MUTATE_REACTION = gql`
  mutation AddReaction($input: ReactionInput) {
    addReaction(input: $input)
  }
`;
